"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/auth";
import { homePathFor } from "@/lib/rbac";

export default function HomePage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading) return;
    if (user) {
      router.replace(homePathFor(user.role));
    } else {
      router.replace("/login");
    }
  }, [loading, user, router]);

  return (
    <div className="auth-wrap">
      <div className="muted">กำลังโหลด…</div>
    </div>
  );
}
